export enum CargoType {
    LCL,
    FCL,
}